/**
 * A simple alternative to lodash.get
 * @param {Object} object
 * @param {Array} path
 */
export default function get(object, path) {
  if (!path.length) {
    return object;
  }
  if (object == null) {
    return undefined;
  }
  return get(object[path.shift()], path);
}
